//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import KeyboardDialog from '../virtual-keyboard/virtualKeyboardDialog.vue';

export default {
  name: 'EmptyBottleContainer',
  components: {
    KeyboardDialog,
  },
  computed: {
    ...mapGetters({
      rxApprovalData: 'rxApproval/getRxApprovalDetail',
    }),
  },
  data() {
    return {
      pinDialogIsOpen: false,
      keyBoardType: '',
      modelName: '',
      labelName: '',
      modelValue: '',
    };
  },
  methods: {
    increaseContainers() {
      this.$store.commit('rxContent/increaseContent', {
        index: this.contentIndex,
        field: 'noOfEmptyBottles',
      });
    },
    decreaseContainers() {
      this.$store.commit('rxContent/decreaseContent', {
        index: this.contentIndex,
        field: 'noOfEmptyBottles',
      });
    },
    checkDialog(KeyboardType, modelName, labelName, index, modelValue) {
      if (this.rxApprovalData.id) {
        this.pinDialogIsOpen = true;
        this.keyBoardType = KeyboardType;
        this.modelName = modelName;
        this.labelName = labelName;
        this.keypadIndex = index;
        this.modelValue = modelValue;
      }
    },
    dialogInputChanges(changes) {
      this.pinDialogIsOpen = changes;
    },
    enterClicked(value) {
      const model = value.modelName;
      this.$store.commit('rxContent/setContentValue', {
        index: this.contentIndex,
        field: model,
        value: +value.input,
      });
    },

  },
  props: {

    noOfEmptyBottles: {
      type: Number,
      default: 1,
    },
    contentIndex: {
      type: Number,
      default: 0,
    },
  },
};
